<script setup>
import { ref, watch, getCurrentInstance, onMounted, nextTick, onBeforeUnmount, computed } from 'vue';
import SVG2FA from '@/assets/images/2fa.svg';
import SVGLogout from '@/assets/images/logout.svg';
import SVGLicenses from '@/assets/images/license.svg';
import SVGReport from '@/assets/images/report.svg';
import SVGPerformance from '@/assets/images/performance.svg';
import SVGRequest from '@/assets/images/request.svg';
import SVGLogo from '@/assets/images/logo-left.svg';
import SVGPlus from '@/assets/images/plus.svg';
import SVGSettings from '@/assets/images/settings.svg';
import SVGTicket from '@/assets/images/ticket.svg';
import SVGPartner from '@/assets/images/partner.svg';
import Register from '@/views/license/account/Register.vue';
import { useStore } from 'vuex';
import { DIALOG, ROLE, POPUP } from '@/constants/index';
import accountAPI from '../../src/apis/accounts/accountAPI.js';
import { useRoute, useRouter } from 'vue-router';
import MenuSVG from '@/assets/images/menu-icon.svg';
import MisaID from '@/commons/misaID.js';
import { createInstance } from 'localforage';
import utility from '@/commons/utility';
import SVGPassword from '@/assets/images/password.svg';
import SVGDateFormat from '@/assets/images/date-format.svg';
import SVGChevron from '@/assets/images/chevron.svg';
import { ModuleContext } from '@/stores/moduleConst.js';
import { loadLanguageAsync } from '@/i18ns/i18n';
import tickets from '@/apis/tickets';
import ticketAPI from '@/apis/tickets';
import requestAPI from '@/apis/request/requestAPI';
import partnerApi from '@/apis/partner';

const { proxy } = getCurrentInstance();
const store = useStore();
const router = useRouter();
const openModal = ref(false);
let src = ref();
let topModal = ref(0);
let context = store.state['context'];
let gContext = store.state['globalcontext'];
let name = context.User?.UserName;
let roleAccount = context.User?.RoleCodes[0];
let roleId = context.User?.RoleIds[0];
let userId = context.User?.UserId;
let top = ref(-1000);
let countRequest = ref(0);
let countTickets = ref(0);
let isCurrentHomePage = window.location.pathname == '/';

const listButton = ref([]);

let isShowFormRegister = ref(false);
let role = ref({});

//Danh sách ngôn ngữ
let languages = ref([]);

// set giá trị mặc định cho combobox
let language = ref({});

async function ChangeLanguage(e) {
  if (language.value.LanguageID) {
    store.commit('context/updateCulture', language.value.LanguageID);
    await loadLanguageAsync(language.value.LanguageID);
  }
}

function updateCultureLang() {
  let lang = store.state.context?.Context?.Culture || 'en-US';
  language.value = {
    LanguageID: lang,
    Description:
      lang == 'en-US'
        ? proxy.$t('i18nAccountingObject.Languages.English')
        : lang == 'de-DE'
        ? proxy.$t('i18nAccountingObject.Languages.German')
        : proxy.$t('i18nAccountingObject.Languages.Vietnamese'),
  };
  languages.value = [
    {
      LanguageID: 'en-US',
      Description: proxy.$t('i18nAccountingObject.Languages.English'),
    },
    {
      LanguageID: 'vi-VN',
      Description: proxy.$t('i18nAccountingObject.Languages.Vietnamese'),
    },
  ];
}
/**Sự kiện bấm vào nút click */
function OpenRegister() {
  store.commit('popup/SHOW_POPUP', {
    data: { company_name: '' },
    type: POPUP.REGISTER_POPUP,
  });
}

function backToHome() {
  router.push('/dashboard');
}

async function resetPassword() {
  let emp = {};
  var data = {
    skip: 0,
    take: -1,
    filter: JSON.stringify([
      {
        Field: 'employee_id',
        Operator: '=',
        Value: userId,
      },
    ]),
    emptyFilter: '',
    columns: '',
  };
  var res = await accountAPI.getAccountPagging(data);
  if (res.Data?.Data?.length > 0) {
    emp = res.Data?.Data[0];
  }
  store.commit('popup/SHOW_POPUP', {
    type: POPUP.RESET_PASSWORD,
    data: emp,
  });
  openModal.value = !openModal.value;
}

async function openModal_click(e) {
  openModal.value = !openModal.value;
}

function closeModal_click() {
  if (openModal) {
    openModal.value = false;
  }
}

function Logout() {
  openModal.value = !openModal.value;
  store.dispatch('context/logout');
  router.push('/login');
}

function openDateFormatPopup() {
  store.commit('popup/SHOW_POPUP', {
    type: POPUP.DATE_FORMAT,
    data: {},
  });
}

const has2FA = computed(
  () =>
    store.state.context.TwoFAInfo?.IsTOTPActive !== undefined ||
    store.state.context.TwoFAInfo?.IsEOTPActive !== undefined
);
function setup2FA() {
  store.commit('popup/SHOW_POPUP', {
    type: POPUP.ENTER_PWD,
    data: {
      onSuccess: () => {
        store.commit('popup/SHOW_POPUP', {
          data: { company_name: '' },
          type: POPUP.TWO_FACTOR_AUTH_INFO,
        });
      },
    },
  });
}

onMounted(async () => {
  updateCultureLang();
});

async function getTotalTicketsNeedApprove() {
  var data = {
    skip: 0,
    take: -1,
    filter: JSON.stringify([
      {
        Field: 'status',
        Operator: '=',
        Value: 0,
      },
    ]),
    emptyFilter: '',
    columns: 'license_ticket_id',
  };

  let res = await ticketAPI.getPaging(data);
  countTickets.value = res.Data?.length || 0;
}

async function getTotalRequestNeedApprove() {
  let filters = [
    {
      Field: 'status',
      Operator: '=',
      Value: 0,
    },
  ];

  if (roleId == ROLE.PARTNER) {
    filters.push({
      Field: 'r.partner_id',
      Operator: '=',
      Value: context.User?.PartnerId,
    });
  }

  if (roleId == ROLE.PARTNERSALES) {
    filters.push({
      Field: 'employee_id',
      Operator: '=',
      Value: userId,
    });
  }

  if (roleId == ROLE.SALES) {
    let partnerIds = [];
    let result = await partnerApi.getPartnersByEmployeeID(userId);
    if (result && result?.Data && result?.Data?.length > 0) {
      partnerIds.concat(result?.Data?.map((item) => item.partner_id));
    }

    let sales = {
      Field: 'employee_id',
      Operator: '=',
      Value: userId,
      Ors: [],
    };

    sales.Ors.push({
      Field: 'r.partner_id',
      Operator: ' IN ',
      Value: partnerIds,
    });

    filters.push(sales);
  }

  var data = {
    skip: 0,
    take: -1,
    sort: '',
    filter: JSON.stringify(filters),
    emptyFilter: 'request',
    columns: ' company_name ',
  };
  let res = await requestAPI.getListRequestNeedApprove(data);
  countRequest.value = res.Data?.Data?.length || 0;
}

onMounted(async () => {
  await checkNumberTiketAndRequest();
});
watch(
  () => store.state.refresh.data,
  async (newValue, oldValue) => {
    await checkNumberTiketAndRequest();
  },
  { deep: true }
);
async function checkNumberTiketAndRequest() {
  let ticket = getTotalTicketsNeedApprove();
  let approve = getTotalRequestNeedApprove();
  await Promise.all([ticket, approve]);
}
</script>

<template>
  <div class="left-menu__button">
    <MenuSvg />
  </div>
  <Transition name="slide-fade">
    <div class="left-menu">
      <div class="left-menu__container">
        <div class="left-menu__top">
          <div class="left-menu__logo">
            <SVGLogo></SVGLogo>
          </div>
        </div>
        <div class="left-menu__contain">
          <div class="ms-button ms-button-secondary left-menu__button-register" @click="OpenRegister">
            <SVGPlus />{{ $t('i18nLeftMenu.Register') }}
          </div>
          <div class="left-menu__list">
            <!-- <router-link to="/tickets" v-if="roleId != ROLE.SALES">
              <SVGTicket /> {{ $t('i18nLeftMenu.Tickets') }}
              <span class="left-menu__number" v-if="countTickets > 0">{{
                countTickets
              }}</span>
            </router-link> -->
            <router-link to="/dashboard"> <SVGPerformance /> {{ $t('i18nLeftMenu.Dashboard') }}</router-link>
            <router-link v-if="roleId != ROLE.PARTNERSALES" to="/report">
              <SVGReport /> {{ $t('i18nLeftMenu.Report') }}</router-link
            >
            <router-link to="/license-page"> <SVGLicenses /> {{ $t('i18nLeftMenu.Licenses') }}</router-link>
            <router-link to="/request-page" :class="{ isCurrentHomePage: isCurrentHomePage }">
              <SVGRequest />{{ $t('i18nLeftMenu.Request') }}
              <span class="left-menu__number" v-if="countRequest > 0">{{ countRequest }}</span></router-link
            >

            <router-link
              to="/partner-page"
              v-if="ROLE.ADMIN == roleId || ROLE.MANAGER == roleId || ROLE.SALES == roleId"
            >
              <SVGPartner /> {{ $t('i18nLeftMenu.Partner') }}
            </router-link>
            <router-link to="/settings" v-if="true"> <SVGSettings /> {{ $t('i18nLeftMenu.Settings') }} </router-link>
          </div>
        </div>
        <div class="left-menu__bottom">
          <q-btn-dropdown
            dropdown-icon="expand_more"
            :ripple="false"
            :unelevated="true"
            class="left-menu__bottom-account"
            @click="onMainClick"
            :auto-close="true"
          >
            <template v-slot:label>
              <div class="left-menu__account" @click="openModal_click">
                <div class="left-menu__account-avatar">
                  <!-- <img src="" alt="" /> -->
                  <div>
                    {{ name[0] }}
                  </div>
                </div>
                <div class="left-menu__account-info">
                  <div class="left-menu__account-name">{{ name }}</div>
                  <div class="left-menu__account-roles">
                    {{ $t(`i18nAccountingObject.Account.${roleAccount}`) }}
                  </div>
                </div>
              </div>
            </template>

            <q-list>
              <q-item v-if="roleId == ROLE.PARTNER" clickable @click="resetPassword()">
                <a class="option-item" style="cursor: pointer">
                  <SVGPassword></SVGPassword>
                  <span>{{ $t('i18nLeftMenu.ChangePassword') }}</span>
                </a>
              </q-item>
              <q-item clickable @click="setup2FA" v-if="has2FA">
                <a class="option-item" style="cursor: pointer">
                  <SVG2FA />
                  Two-Factor Authentication
                </a>
              </q-item>
              <q-item v-if="roleId == ROLE.ADMIN || roleId == ROLE.SALES || roleId == ROLE.MANAGER" clickable @click="openDateFormatPopup">
                <a class="option-item" style="cursor: pointer">
                  <SVGDateFormat />
                  {{ $t('i18nLeftMenu.DateFormat') }}
                </a>
              </q-item>
              <q-item clickable @click="Logout">
                <a class="option-item" style="cursor: pointer">
                  <SVGLogout />
                  {{ $t('i18nLeftMenu.Logout') }}
                </a>
              </q-item>
            </q-list>
          </q-btn-dropdown>
          <q-select
            class="left-menu__bottom-change-language"
            v-model="language"
            :options="languages"
            borderless
            option-value="LanguageID"
            option-label="Description"
            input-style="height: 64px"
            @update:model-value="
              (val) => {
                ChangeLanguage();
              }
            "
            ><template v-slot:before>
              <q-icon name="language" />
            </template>
          </q-select>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
@import '../assets/scss/layouts/leftMenu.scss';

.left-menu__icon-log-out {
  height: 24px;
  width: 24px;
}

.left-menu__account-name {
  text-transform: uppercase;
}

.left-menu__account-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #ffffff;
  background: #5ab9c1;
  div {
    height: fit-content;
    width: fit-content;
    text-transform: uppercase;
  }
}

.left-menu__bottom-account {
  background: #f5f5f5;
  padding: 0 10px 0 0;
  margin-bottom: 16px;
  .q-item:hover {
    color: #0967b9 !important;
  }
}

.isCurrentHomePage {
  color: #0967b9 !important;
}

.option-item {
  align-items: center;
  display: flex;
  gap: 8px;
}

.q-field.left-menu__bottom-change-language {
  .q-field__marginal,
  .q-field__control,
  .q-field__control:before,
  .q-field__native {
    height: 64px !important;
    min-height: 64px !important;
  }
}

.left-menu__bottom-change-language {
  margin-left: -16px;
  margin-right: -16px;
  border-top: 1px solid #e0e0e0;
  padding: 0px 16px;
}
.left-menu__number {
  display: flex;
  height: 20px;
  width: 20px;
  background: #da3636;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}
:deep(.q-field__append) {
  padding-left: 0px;
}
:deep(.q-field__before),
:deep(.q-field__prepend) {
  padding-left: 0px;
  padding-right: 5px;
}
</style>
